import { MapPin } from "lucide-react";

const CITIES = [
  "St. George", "Washington", "Hurricane", "Ivins", "Santa Clara",
  "Cedar City", "Springdale", "Zion area", "Kanab", "Enterprise",
  "Brian Head", "Beaver", "Surrounding areas",
];

const ZION = "https://images.pexels.com/photos/14632444/pexels-photo-14632444.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function ServiceArea() {
  return (
    <div>
      <section className="section">
        <div className="mx-auto max-w-6xl">
          <div className="overline">Service Area</div>
          <h1 className="h-display mt-3 text-5xl md:text-6xl leading-[1.05]">Serving all of Southern Utah.</h1>
          <p className="mt-6 text-graphite max-w-2xl text-lg leading-relaxed">
            From the red-rock canyons of Zion to the pine forests of Brian Head, our luxury restroom trailers reach venues throughout the region.
          </p>
        </div>
      </section>

      <section className="pb-24 px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-6xl grid md:grid-cols-2 gap-10 items-start">
          <div className="grid grid-cols-2 gap-3">
            {CITIES.map((c) => (
              <div key={c} className="card-soft p-5 flex items-center gap-3">
                <MapPin className="h-4 w-4 text-pebble" />
                <span className="text-sm">{c}</span>
              </div>
            ))}
          </div>
          <div className="relative">
            <img src={ZION} alt="Zion" className="w-full h-[480px] object-cover rounded-3xl" />
          </div>
        </div>

        <div className="mx-auto max-w-6xl mt-12 card-soft p-8">
          <div className="overline">Beyond the standard area</div>
          <p className="text-graphite mt-3 leading-relaxed">
            Locations outside our normal service area require manual approval. Delivery fees are based on mileage, travel time, event location, and delivery conditions — we'll confirm your delivery estimate before your deposit is finalized.
          </p>
        </div>
      </section>
    </div>
  );
}
